import { restClient } from '@/Core'
import type { Chat, User } from '../Contracts'
import { extractChatUsers, mapApiChat, type ApiChat } from '../Helpers/apiMappers'

/**
 * Власницькі операції над чатом (Фаза 4). Бек захищає кожну Voter-ом
 * (власник/учасник) — фронтові кнопки лише віддзеркалюють ті самі правила
 * через chat.ownerId.
 */

/** PATCH назви (власник). Повертає оновлений чат */
export const RenameChatTask = async (chatId: string, name: string): Promise<Chat> => {
    const response = (await restClient.patch(`/services/chat/chats/${chatId}`, {
        json: { name },
    })) as ApiChat | null

    return mapApiChat(response ?? {})
}

/** Завантаження аватарки (власник). Повертає чат зі свіжим avatarUrl */
export const UploadChatAvatarTask = async (chatId: string, file: File): Promise<Chat> => {
    const body = new FormData()
    body.append('file', file, file.name)

    const response = (await restClient.post(
        `/services/chat/chats/${chatId}/avatar`,
        { body },
        { isNotHeaderAddContentType: true }
    )) as ApiChat | null

    return mapApiChat(response ?? {})
}

/** Додавання учасників (власник); повертає uuid реально доданих */
export const AddChatParticipantsTask = async (chatId: string, userIds: string[]): Promise<string[]> => {
    const response = (await restClient.post(`/services/chat/chats/${chatId}/participants`, {
        json: { userIds },
    })) as { addedUserIds?: string[] } | null

    return response?.addedUserIds ?? []
}

/** Видалення учасника (власник, не себе) */
export const RemoveChatParticipantTask = async (chatId: string, userId: string): Promise<void> => {
    await restClient.delete(`/services/chat/chats/${chatId}/participants/${userId}`)
}

/** Вихід із чату (учасник, не власник) */
export const LeaveChatTask = async (chatId: string): Promise<void> => {
    await restClient.post(`/services/chat/chats/${chatId}/leave`, { json: {} })
}

/** Видалення чату (власник, не entity-чат) */
export const DeleteChatTask = async (chatId: string): Promise<void> => {
    await restClient.delete(`/services/chat/chats/${chatId}`)
}

/** Хелпер повторного мапінгу разом з юзерами (rename/avatar відповіді) */
export const mapChatResponse = (api: ApiChat): { chat: Chat; users: User[] } => ({
    chat: mapApiChat(api),
    users: extractChatUsers(api),
})
